/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./originatorDevicesList.vue?vue&type=template&id=6794453a&scoped=true"
import script from "./originatorDevicesList.vue?vue&type=script&lang=js"
export * from "./originatorDevicesList.vue?vue&type=script&lang=js"
import style0 from "./originatorDevicesList.vue?vue&type=style&index=0&id=6794453a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6794453a",
  null
  
)

export default component.exports